module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-badge",
    class: _vm.badgeTheme
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.badgeReady),
      expression: "badgeReady"
    }],
    staticClass: "badge-wrapper"
  }, [_c('div', {
    staticClass: "badge-progress"
  }, [_c('svg', {
    attrs: {
      "id": "progress",
      "width": "64",
      "height": "64",
      "viewBox": "0 0 100 100"
    }
  }, [_c('circle', {
    staticClass: "progress__meter",
    attrs: {
      "cx": "50%",
      "cy": "50%",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-ft",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-pp",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-at",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress__value progress__value-rt",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "38",
      "stroke-width": "5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "badge-text"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "level",
    style: ({
      backgroundColor: _vm.getCompanyLevel('color')
    })
  }, [_vm._v("\n        " + _vm._s(this.getCompanyLevel('name')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b06bd03","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Badge.vue
// module id = 986
// module chunks = 0